import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSliderModule} from '@angular/material/slider';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DragDropDirective} from '@directives/drag-drop.directive';
import {MatInputFormattedDirective} from '@directives/mat-input-formatted.directive';
import {TypeWriterPlaceholderDirective} from '@directives/type-writer-placeholder.directive';
import {FuseSharedModule} from '@fuse/shared.module';
import {StarRatingModule} from '@modules/star-rating/star-rating.module';
import {TranslateModule} from '@ngx-translate/core';
import {CountdownPipe} from '@pipes/countdown.pipe';
import {TruncatePipe} from '@pipes/truncate.pipe';
import {NgxDocViewerModule} from 'ngx-doc-viewer';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,

        FuseSharedModule,

        MatAutocompleteModule,
        MatBadgeModule,
        MatButtonModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatRadioModule,
        MatSelectModule,
        MatSliderModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,

        NgxDocViewerModule,
        StarRatingModule,
    ],
    providers: [],
    declarations: [
        CountdownPipe,
        TruncatePipe,
        DragDropDirective,
        MatInputFormattedDirective,
        TypeWriterPlaceholderDirective,
    ],
    exports: [
        CommonModule,
        TranslateModule,

        FuseSharedModule,

        MatAutocompleteModule,
        MatBadgeModule,
        MatButtonModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatRadioModule,
        MatSelectModule,
        MatSortModule,
        MatSliderModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,

        CountdownPipe,
        TruncatePipe,
        DragDropDirective,
        MatInputFormattedDirective,
        TypeWriterPlaceholderDirective,
    ],
})
export class AppSharedModule {

}
